import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const headerClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginBottom: Spacing.MD,
});

export const iconWrapperClassName = css({
  background: Colors.BrandLight,
  borderRadius: 100,
  padding: Spacing.SM,
});

export const iconClassName = css({
  color: Colors.Brand,
  height: 16,
  width: 16,
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  marginLeft: Spacing.SM,
});

export const bodyClassName = css({
  display: 'grid',
  gap: Spacing.MD,
  marginTop: Spacing.LG,
});
